import { useState } from "react";
import classes from "../homePageNew.module.css";
import { extractDomain } from "../../../utils/helpers";

const GEMINI_LOGO = "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg";

/**
 * Model logo, same sourcing as the old Home page's per-LLM table
 * (HomePage/SummaryCard/CardTable.js): the internal web pseudo-LLM gets
 * /menu.png, Google models get the Gemini sparkle, everything else comes
 * from logo.dev by the model's domain. Falls back to the model's initial
 * if there's no domain or the image fails to load.
 */
export default function MonitoringLlmLogo({ domain, provider, name }) {
  const [failed, setFailed] = useState(false);
  const isWeb = provider === "Internal-WebLLM";
  const host = domain ? extractDomain(domain) : null;

  let src = null;
  if (isWeb) src = "/menu.png";
  else if (host === "google.com") src = GEMINI_LOGO;
  else if (host) src = `https://img.logo.dev/${host}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`;

  if (!src || failed) {
    return <span className={classes.monLlmLogoFallback}>{(name || "?").charAt(0).toUpperCase()}</span>;
  }
  return <img className={classes.monLlmLogo} src={src} alt="" onError={() => setFailed(true)} />;
}
